/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkCustomTemplateRequest } from '../../models/bulk-custom-template-request';
import { BulkModifiersTemplateRequest } from '../../models/bulk-modifiers-template-request';
import { BulkModifiersWithFreeTextTemplateRequest } from '../../models/bulk-modifiers-with-free-text-template-request';
import { BulkProductsTemplateRequest } from '../../models/bulk-products-template-request';

export interface SkumapTemplatesTemplateIdAssociatePut$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
      body: (BulkProductsTemplateRequest | BulkModifiersTemplateRequest | BulkCustomTemplateRequest | BulkModifiersWithFreeTextTemplateRequest)
}

export function skumapTemplatesTemplateIdAssociatePut(http: HttpClient, rootUrl: string, params: SkumapTemplatesTemplateIdAssociatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesTemplateIdAssociatePut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

skumapTemplatesTemplateIdAssociatePut.PATH = '/skumap/templates/{templateId}/associate';
